import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  START_GET_SEARCH_REPEAT_ORDER,
  RESET_REPEAT_ORDER_STATE,
} from "Actions/RepeatOrderAction";
import {
  RESET_ORDER_PAD_STATE,
  START_CREATE_TODAY_ORDER_PAD,
} from "Actions/OrderPadAction";
import * as yup from "yup";
import { useFormik } from "formik";
import moment from "moment";
import { useNotification } from "Hooks/NotificationManager";
import { useXssGuard } from "Hooks/useXssGuard";
import { useNavigate } from "react-router-dom";
import {
  START_CREATE_RX,
  RESET_COLLECTION_STATE,
  START_GET_COLLECTION_LIST,
} from "Actions/CollectionAction";
import { ReactComponent as Phone } from "Assets/Icons/phone.svg";
import { ReactComponent as Email } from "Assets/Icons/email (1).svg";
import { ReactComponent as Fax } from "Assets/Icons/FaxIco.svg";
import { ReactComponent as Other } from "Assets/Icons/Other.svg";
import OptionForAddToOrderAndOrderNew from "./OptionForAddToOrderAndOrderNew";
import AddToOrderList from "./AddToOrderList";
import OrderToNewRx from "./OrderToNewRx";
import DrugsDialog from "Components/RepeatOrder/DrugsDialog";
import ViewOrderDialog from "Components/Common/Dialog/ViewOrderDialog";
import FaxDialog from "Components/Common/Dialog/FaxDialog";
import PatientCreateDialog from "./PatientCreateDialog";
import { getLocalStorage } from "utils/generalUtils";
import { START_GET_HOME_LIST } from "Actions/HomeAction";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import { useSelector } from "react-redux";
import SubscriptionWaringDailog from "Components/Common/Dialog/SubscriptionWaringDailog";

const CollectionRXCreateMain = (props) => {
  const {
    getCollectionRxAction,
    createOrderPadData,
    createTodayOrderPadAction,
    createTodayOrderPadData,
    getSearchRepeatOrderAction,
    searchRepeatOrder,
    resetOrderPadState,
    createCollectionRxAction,
    createRxDetails,
    resetCollectionRxState,
    resetRepeatOrderState,
    getHomeListAction,
  } = props;
  const formState = {
    patient_id: "",
    order_id: "",
    comment: "",
    medication: [],
    created_user_type: "",
    order_date: new Date(),
    ordering_method: "email",
    surgery_id: "",
    surgery_info: {},
    pharmacy_id: "",
    pharmacy_info: {},
    number_of_medication: "",
  };

  const navigate = useNavigate();
  const notification = useNotification();
  const [orderPadData, setOrderPadData] = useState(formState);
  const [selectedPatientInfo, setSelectedPatientInfo] = useState({});
  const [showWholeForm, setShowWholeForm] = useState(false);
  const [medications, setMedications] = useState([]);
  const [createDrug, setCreateDrug] = useState(false);
  const [formPayload, setFormPayload] = useState({});
  const [openViewOrder, setOpenViewOrder] = useState(false);
  const [checkAllAction, setCheckAllAction] = useState(false);
  const [openFaxOrder, setOpenFaxOrder] = useState(false);
  const [showOrderList, setShowOrderList] = useState(false);
  const [showCreateNewRx, setShowCreateNewRx] = useState(false);
  const [showNoOfMedication, setShowNoOfMedication] = useState(false);
  const [orderType, setOrderType] = useState("");
  const [fax, setFax] = useState(false);
  const [phone, setPhone] = useState(false);
  const [viewOrderData, setViewOrderData] = useState({});
  const [isOpenNewPatientPopup, setIsOpenNewPatientPopup] = useState(false);
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const loginUserDetail = useSelector((state) => state.user);
  const pathName = window.location.pathname;
  const OrderingMethod = [
    { item: "Phone", type: "phone", icon: <Phone /> },
    { item: "Fax", type: "fax", icon: <Fax /> },
    { item: "Email", type: "email", icon: <Email /> },
    {
      item: "Other",
      type: "other",
      icon: <Other />,
    },
  ];
  const query = new URLSearchParams(window.location.search);
  const OrderBYList = [
    { item: "Patient", type: "patient" },
    { item: "Staff", type: "staff" },
  ];
  const [orderBy, setOrderBy] = useState("");
  const [showMedication, setShowMedication] = useState(
    query.get("actionType") === "repeatOrderPage" ? false : true
  );
  const [orderActionType, setOrderActionTypeActionType] = useState("");
  const [listOpen, setListOpen] = useState(false);
  const medicationRef = React.useRef(null);
  const quantityRef = React.useRef(null);
  const [inAddRx, setInAddRx] = useState(false);
  const allowPatientActionTypes = ["repeatOrderPage", "createNewRx"];
  const currentPageType =
    allowPatientActionTypes.indexOf(query.get("actionType")) === -1
      ? "orderPad"
      : "orderPad collection";
  const blankMediation = medications.filter((item) => {
    return item?.name?.trim() === "";
  });

  /** return action ticked medication array filter */
  const medicationActionCheck = medications?.filter((item) => {
    return item.action === true;
  });

  /** Validation schema */
  let orderPadCreateSchema = {
    surgery_id: yup
      .string()
      .required("The surgery name field is required."),
  };

  /** validation Schema */
  let collectionRxSchema = {
    order_date: yup
      .date()
      .nullable()
      .typeError("Date must be follow this format DD-MM-YYYY")
      .required("The next order date field is required."),
    surgery_id: yup
      .string()
      .required("The surgery name field is required."),
    number_of_medication: yup
      .number()
      .nullable(true)
      .min(1, "The number must must be greater than 0."),
    created_user_type: yup
      .string()
      .required("Please select patient order or staff order."),
  };
  let collectionRxNSchema = {
    order_date: yup
      .date()
      .nullable()
      .typeError("Date must be follow this format DD-MM-YYYY")
      .required("The next order date field is required."),
    surgery_id: yup
      .string()
      .required("The surgery name field is required."),
    // number_of_medication: yup
    //   .number()
    //   .nullable(true)
    //   .required("The number of medication field is required.")
    //   .min(1, "The number must must be greater than 0."),
    created_user_type: yup
      .string()
      .required("Please select patient order or staff order."),
  };
  /** update schema */
  let schema = {};
  if (orderType === "createNewOrder") {
    schema = orderPadCreateSchema;
  } else if (orderType === "addOrder") {
    if (showNoOfMedication) {
      schema = collectionRxNSchema;
    } else {
      schema = collectionRxSchema;
    }
  } else {
    schema = {
      ...orderPadCreateSchema,
      ...collectionRxSchema,
    };
  }

  const orderPadSchema = yup.object().shape({ ...schema });

  /** validate drug */
  const validateDrug = (validationCheckFor = "submit") => {
    if (validationCheckFor === "onChange") {
      const _validateMedication = medications?.map((item) => {
        return (item = {
          ...item,
          errors: {
            name: "",
            quantity: "",
          },
        });
      });
      setMedications(_validateMedication);
      return 0;
    }

    let errorCounter = 0;
    const _validateMedication = medications?.map((item) => {
      if (validationCheckFor === "add") {
        if (item.name.trim() === "" || item.quantity === "") {
          errorCounter++;
        }
      } else {
        item.errors = {
          name: "",
          quantity: "",
        };

        if (item.name.trim() === "" && item.quantity !== "") {
          errorCounter++;
          item.errors.name = "Please enter medication";
        } else if (item.name.trim() !== "") {
          // if (item.quantity === "") {
          //   errorCounter++;
          //   item.errors.quantity = "Please enter quantity";
          // } else

          if (item.quantity && item.quantity <= 0) {
            errorCounter++;
            item.errors.quantity = "The quantity  must be greater than 0.";
          }
          // else if (isNaN(item.quantity)) {
          //   item.errors.quantity = "The quantity must be a number.";
          //   errorCounter++;
          // }
        }
      }
      return item;
    });
    setMedications(_validateMedication);
    return errorCounter;
  };

  /** Submit function */
  const handleCreateOrderPad = (formValues) => {
    // if (loginUserDetail?.loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    /** Validate drugs */
    if (showMedication) {
      if (validateDrug() > 0) {
        return false;
      }
    }

    const payload = {
      patient_id:
        query.get("actionType") === "repeatOrderPage"
          ? query.get("patient_id")
          : formValues?.patient_id,
    };
    if (orderType === "addOrder") {
      payload.created_user_type = orderBy;
    }

    if (query.get("actionType") === "repeatOrderPage") {
      payload.order_id = query.get("orderId");
    }

    if (orderType === "addOrder") {
      payload.order_date = moment(new Date(formValues?.order_date)).format(
        "YYYY-MM-DD"
      );
    }
    if (orderType === "addOrder") {
      payload.medication_type = `${showMedication ? "specific" : "unspecific"}`;
    }
    if (formValues.comment) {
      payload.comment = formValues?.comment;
    }

    if (query.get("actionType") !== "createNewRx") {
      if (formValues.ordering_method) {
        payload.ordering_method = formValues?.ordering_method;
      }
    }

    if (orderType === "createNewOrder") {
      if (formValues.ordering_method) {
        payload.ordering_method = formValues?.ordering_method;
      }
      let tempMail = `${"\r\n \r\n"} Dear ${searchRepeatOrder?.data?.data?.surgery_name?.name
        },${"\r\n \r\n"} Please can I order a repeat prescription for the following ${"\r\n \r\n"} Patient name: ${searchRepeatOrder?.data?.data?.name[0]
        } ${searchRepeatOrder?.data?.data?.last_name
          ? searchRepeatOrder?.data?.data?.last_name
          : ""
        }  ${"\r\n \r\n"} DOB : ${searchRepeatOrder?.data?.data?.dob
          ? moment(new Date(searchRepeatOrder?.data?.data?.dob)).format(
            "DD MMM YYYY"
          )
          : "N / A"
        }  ${"\r\n \r\n"} Medication:
      ${showNoOfMedication === true
          ? `${values?.number_of_medication}`
          : medications
            ?.map((item) =>
              item.action
                ? `${"\r\n"} ${item?.drug_name ? item?.drug_name : item?.name
                } ${item?.quantity ? `/ Quantity:${item?.quantity}` : ""
                }  ,`
                : ``
            )
            .join("")
        }
      ${"\r\n \r\n"} Best regards, ${"\r\n \r\n"} ${loginUserDetail?.loginUserDetail?.data?.data?.name
        }${"\r\n"} ${searchRepeatOrder?.data?.data?.pharmacy_name?.name
        } ${"\r\n \r\n"}`;
      if (formValues.ordering_method === "email") {
        payload.message = tempMail;
        payload.subject = "Prescription Order Request";
        payload.email = searchRepeatOrder?.data?.data?.surgery_name?.email;
      }
    }

    if (formValues.comment) {
      payload.comment = formValues?.comment;
    }

    const checkMedication = medicationActionCheck.length > 0;

    let actionCheckedCounter = 0;
    let _medications = medications;
    if (checkMedication) {
      _medications = _medications.filter((item) => {
        delete item.errors;
        if (item.name.trim() !== "") {
          /** Return only action checked */
          if (item.action === true) {
            /** Increment counter */
            actionCheckedCounter++;
            return item;
          }
        }
      });
    } else {
      actionCheckedCounter = 1;
    }

    if (actionCheckedCounter > 0) {
      /** If specific medication ticked */
      if (showMedication) {
        /** If medication action ticked */
        if (checkMedication) {
          /** If drug not present for order and mode is create */
          payload.medication = [];
          payload.new_medication = [];
          _medications.map((item) => {
            const { id, name, quantity } = item;
            if (!item.hasOwnProperty("isNew")) {
              payload.medication.push({
                id,
              });
            } else {
              // payload.new_medication = [];
              payload.new_medication.push({
                drug_name: name,
                quantity,
                action: true,
              });
            }
          });
        } else {
          notification.error("Please select medication");
        }
      } else {
        // payload.number_of_medication = formValues?.number_of_medication;
      }

      let _payload = {
        ...payload,
      }

      if (!selectedPatientInfo?.surgery_name?.id && values?.surgery_id) {
        _payload.surgery_id = values?.surgery_id;
      }

      setFormPayload(_payload);
      finalSubmitForm(_payload);
    } else {
      notification.error("Please select medication");
    }
    // }
  };

  /**handle submit form  */
  const finalSubmitForm = (payload) => {
    const _payload = {
      ...formPayload,
      ...payload,
    };
    if (orderType === "addOrder") {
      /** Create Collection API Call */
      createCollectionRxAction(_payload);
      setInAddRx(true);
    } else {
      /** Create OrderPad API Call */
      createTodayOrderPadAction(_payload);
      setInAddRx(true);
    }
  };

  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    handleBlur,
    resetForm,
    setErrors,
    setFieldValue,
    setFieldTouched,
  } = useFormik({
    initialValues: { ...orderPadData },
    validationSchema: orderPadSchema,
    enableReinitialize: true,
    onSubmit: handleCreateOrderPad,
  });

  const { guardedSubmit: xssGuardedCreateOrderPad } = useXssGuard(handleCreateOrderPad);

  /** Set handle change for show patient details */
  const handlePatientDetailsChange = (value) => {
    /** If value selected */
    if (value) {
      setMedications([]);
      const newInitialData = {
        ...formState,
        patient_id: value?.id,
      };
      setOrderPadData(newInitialData);
      resetForm({ values: newInitialData });
      setShowMedication(true);
      setShowNoOfMedication(false);
      setCheckAllAction(false);
      setOrderBy("");
      setShowWholeForm(true);
      getSearchRepeatOrderAction(value?.id);
    } else {
      /** If clear */
      setShowWholeForm(false);
      setMedications([]);
      setOrderPadData(formState);
      setShowMedication(true);
      setShowNoOfMedication(false);
      setCheckAllAction(false);
      setOrderBy("");
      resetForm();
    }
  };

  /** handle click add drug  */
  const handleClickAddDrug = () => {
    setMedications(
      medications.concat([
        {
          id: "",
          name: "",
          quantity: "",
          action: false,
          errors: {
            name: "",
            quantity: "",
          },
          isNew: true,
        },
      ])
    );
  };

  /** handle drug change */
  const handleDrugChange = (e, index, rowInfo) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      ...(rowInfo
        ? {
          ...rowInfo,
          meditation_id: rowInfo.id,
        }
        : {
          id: "",
          name: "",
          meditation_id: "",
        }),
    };
    setMedications([...allDrug]);
    validateDrug("onChange");
  };

  /** handle change quantity */
  const handleChangeQuantity = (e, index) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      quantity: e.target.value,
    };
    setMedications([...allDrug]);
    validateDrug("onChange");
  };

  /** Submit patient info call back function */
  const callBackOnSubmitPatientInfo = () => {
    /** List api call */
    getSearchRepeatOrderAction(
      selectedPatientInfo?.patient_id || selectedPatientInfo?.id
    );
  };

  /** Cancel Call back function */
  const callBackOnCancelPatientInfo = () => { };

  /** set search order data */
  useEffect(() => {
    if (
      currentPageType === "orderPad" ||
      (currentPageType === "orderPad collection" &&
        !searchRepeatOrder?.loading &&
        Object.keys(searchRepeatOrder?.data || {})?.length > 0)
    ) {
      setSelectedPatientInfo({
        ...selectedPatientInfo,
        last_name: searchRepeatOrder?.data?.data?.last_name,
        name: searchRepeatOrder?.data?.data?.name,
        dob: searchRepeatOrder?.data?.data?.dob
          ? searchRepeatOrder?.data?.data?.dob
          : "",
        surgery_name: searchRepeatOrder?.data?.data?.surgery_name
      });
      setFieldValue("name", searchRepeatOrder?.data?.data?.name);
      setFieldValue(
        "surgery_info",
        searchRepeatOrder?.data?.data?.surgery_name
      );
      setFieldValue(
        "surgery_id",
        searchRepeatOrder?.data?.data?.surgery_name.id
      );
      setFieldValue(
        "pharmacy_info",
        searchRepeatOrder?.data?.data?.pharmacy_name
      );
      setFieldValue(
        "pharmacy_id",
        searchRepeatOrder?.data?.data?.pharmacy_name.id
      );
      setFieldValue(
        "dob",
        searchRepeatOrder?.data?.data?.dob
          ? searchRepeatOrder?.data?.data?.dob
          : ""
      );
      setFieldValue(
        "ordering_method",
        searchRepeatOrder?.data?.data?.surgery_name?.ordering_method
      );
      const actionedCheckedMedications =
        medicationActionCheck?.map((item) => item.id) || [];
      const manipulateDrugs = searchRepeatOrder?.data?.data?.drugs?.map(
        (item) => {
          item.action = actionedCheckedMedications.includes(item.id);
          return item;
        }
      );
      /** filter duplicate drugs */
      const uniqueMeditation = manipulateDrugs?.reduce(
        (accumulator, current) => {
          if (!accumulator.find((item) => item.name === current.name)) {
            accumulator.push(current);
          }
          return accumulator;
        },
        []
      );
      setMedications(uniqueMeditation);
    }
  }, [searchRepeatOrder]);

  /** Create & edit order loading  true useEffect */
  useEffect(() => {
    if (
      (!createOrderPadData?.loading &&
        Object.keys(createOrderPadData?.data || {})?.length > 0) ||
      (!createTodayOrderPadData?.loading &&
        Object.keys(createTodayOrderPadData?.data || {})?.length > 0)
    ) {
      resetForm();
      setShowWholeForm(false);
      setSelectedPatientInfo({});
      /** Fire action to reset redux */
      resetOrderPadState("createOrderPadData");
      resetRepeatOrderState("searchRepeatOrder");
      resetOrderPadState("createTodayOrderPadData");
      resetCollectionRxState("createRxDetails");
    }
  }, [createOrderPadData, createTodayOrderPadData]);

  /** Collection Rx Loading useEffect */
  useEffect(() => {
    if (
      !createRxDetails?.loading &&
      Object.keys(createRxDetails?.data || {})?.length > 0
    ) {
      resetForm();
      setShowWholeForm(false);
      setSelectedPatientInfo({});
      /** Fire action to reset redux */
      resetCollectionRxState("createRxDetails");
      resetRepeatOrderState("searchRepeatOrder");
    }
  }, [createRxDetails]);

  /** Collection Rx success useEffect */
  useEffect(() => {
    let payload = {
      offset: 0,
      is_chase_up: getLocalStorage("chaseUp") === "true" ? true : false,
      type: "un_collected",
    };
    let payLoad = {};
    if (createRxDetails?.data?.success === true && inAddRx) {
      setInAddRx(false);
      navigate(pathName);
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all"
      ) {
        payload = {
          offset: 0,
          is_chase_up: getLocalStorage("chaseUp") === "true" ? true : false,
          type: "un_collected",
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        getCollectionRxAction(payload);
      }
      // getCollectionRxAction(payload);
      getHomeListAction(payLoad);
    }
  }, [createRxDetails?.data?.success]);

  /** Create & edit order Success redirect to order page */
  useEffect(() => {
    let payload = {
      offset: 0,
      is_chase_up: getLocalStorage("chaseUp") === "true" ? true : false,
      type: "un_collected",
    };
    let payLoad = {};
    if (createOrderPadData?.data?.success === true && inAddRx) {
      setInAddRx(false);
      navigate(pathName);
      setSelectedPatientInfo({});
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all"
      ) {
        payload = {
          offset: 0,
          is_chase_up: getLocalStorage("chaseUp") === "true" ? true : false,
          type: "un_collected",
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        getCollectionRxAction(payload);
      } else {
        getCollectionRxAction(payload);
      }
      getHomeListAction(payLoad);
    } else if (createTodayOrderPadData?.data?.success === true && inAddRx) {
      setInAddRx(false);
      navigate(pathName);
      setSelectedPatientInfo({});
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all"
      ) {
        payload = {
          offset: 0,
          is_chase_up: getLocalStorage("chaseUp") === "true" ? true : false,
          type: "un_collected",
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        getCollectionRxAction(payload);
      }
      getHomeListAction(payLoad);
    }
  }, [
    createOrderPadData?.data?.success,
    createTodayOrderPadData?.data?.success,
  ]);

  /** Sever side error useEffect */
  useEffect(() => {
    const errors =
      query.get("actionType") === "repeatOrderPage"
        ? createOrderPadData?.error?.errors
        : createTodayOrderPadData?.error?.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[0];
        return item;
      });
      setErrors(obj);
    }
  }, [createOrderPadData?.error, createTodayOrderPadData.error]);

  /** api call patient info */
  useEffect(() => {
    if (query.get("actionType") !== "repeatOrderPage") {
      setSelectedPatientInfo({});
    }
  }, []);

  /** handle action change */
  const handleChangeAction = (e, index) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      action: !allDrug[index]?.action,
    };
    setMedications([...allDrug]);
  };

  /** get medication data */
  useEffect(() => {
    const checkAction = medications?.filter((item) => {
      return item.action;
    });
    setCheckAllAction(checkAction?.length === medications?.length);
  }, [medications]);

  /** handle dialog of collect medication */
  const handleDialog = (medications = [], numberOfMedication = 0, items) => {
    let tempData = {};
    /** search repeat order data */
    let tempCollected = 0;
    let tempRemoved = 0;
    searchRepeatOrder?.data?.data?.data?.patient_number_of_medication?.map(
      (item, index) => {
        if (item.status === "Collected") {
          tempCollected += parseInt(item.pnom_medication_no);
        }
        if (item.status === "Removed") {
          tempRemoved += parseInt(item.pnom_medication_no);
        }
      }
    );
    let tempNumberOfMedication =
      searchRepeatOrder?.data?.data?.number_of_medication || numberOfMedication;
    tempData = {
      medication:
        medications.length > 0
          ? medications
          : searchRepeatOrder?.data?.data?.drugs,
      surgeryName: searchRepeatOrder?.data?.data?.surgery_name?.name || values?.surgery_info?.name,
      surgeryEmail: searchRepeatOrder?.data?.data?.surgery_name?.email || values?.surgery_info?.email,
      dob: searchRepeatOrder?.data?.data?.dob
        ? searchRepeatOrder?.data?.data?.dob
        : "",
      nhs_number: searchRepeatOrder?.data?.data?.nhs_number,
      name: searchRepeatOrder?.data?.data?.name,
      last_name: searchRepeatOrder?.data?.data?.last_name,
      medication_type: showNoOfMedication === true ? "number" : "specific",
      number_of_medication: tempNumberOfMedication,
      medicationCollected: tempCollected,
      medicationRemoved: tempRemoved,
      medicationUncollected:
        tempNumberOfMedication - tempCollected - tempRemoved,
      phone: searchRepeatOrder?.data?.data?.surgery_name?.phone || values?.surgery_info?.phone,
      fax: searchRepeatOrder?.data?.data?.surgery_name?.fax || values?.surgery_info?.fax,
    };

    if (!selectedPatientInfo?.surgery_name?.id && values?.surgery_id) {
      tempData.surgery_id = values?.surgery_id
    }

    setViewOrderData(tempData);
    if (items === "email" || items === null) {
      setOpenViewOrder(true);
    } else {
      if (items === "fax") {
        setFax(true);
      }
      if (items === "phone") {
        setPhone(true);
      }
      setOpenFaxOrder(true);
    }
  };

  /** handle submit form on success */
  const onSuccessOfSubmitPatientForm = (responseData) => {
    const data = responseData;
    const { id, name, last_name, dob, status } = data;
    const objPatientInfo = {
      id,
      name,
      last_name,
      dob,
      status,
    };
    setFieldValue("name", name);
    setSelectedPatientInfo(objPatientInfo);
    setFieldValue("patient_id", id);
    setShowWholeForm(true);
    setFieldValue("surgery_info", {
      id: responseData?.surgery?.id,
      email: responseData?.surgery?.email,
      name: responseData?.surgery?.name,
    });
    setFieldValue("surgery_id", responseData?.surgery?.id);
    setFieldValue("surgery_info", {
      id: responseData?.surgery?.id,
      email: responseData?.surgery?.email,
      name: responseData?.surgery?.name,
    });
    setFieldValue("surgery_id", responseData?.surgery?.id);
    setFieldValue("pharmacy_info", {
      id: responseData?.surgery?.id,
      name: responseData?.pharmacy?.name,
    });
    setFieldValue("pharmacy_id", responseData?.pharmacy?.id);

    /** drug data set  */
    const drugInfo = responseData?.drugs?.map((item) => {
      return item;
    });
    /** filter duplicate drugs */
    const uniqueMeditation = drugInfo?.reduce((accumulator, current) => {
      if (!accumulator.find((item) => item.name === current.name)) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    setMedications(uniqueMeditation);
  };

  return (
    <>
      <OptionForAddToOrderAndOrderNew
        setSelectedPatientInfo={setSelectedPatientInfo}
        setOrderType={setOrderType}
        setShowOrderList={setShowOrderList}
        setShowCreateNewRx={setShowCreateNewRx}
        setOrderPadData={setOrderPadData}
        formState={formState}
        setShowWholeForm={setShowWholeForm}
        setListOpen={setListOpen}
        showOrderList={showOrderList}
        showCreateNewRx={showCreateNewRx}
      />
      {(query.get("actionType") === "createNewRx" ||
        currentPageType === "orderPad") && (
          <AddToOrderList
            searchRepeatOrder={searchRepeatOrder}
            handleSubmit={handleSubmit}
            selectedPatientInfo={selectedPatientInfo}
            query={query}
            setSelectedPatientInfo={setSelectedPatientInfo}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            handlePatientDetailsChange={handlePatientDetailsChange}
            currentPageType={currentPageType}
            touched={touched}
            errors={errors}
            setCreateDrug={setCreateDrug}
            medications={medications}
            values={values}
            handleChange={handleChange}
            OrderBYList={OrderBYList}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            navigate={navigate}
            orderType={orderType}
            showMedication={showMedication}
            setShowMedication={setShowMedication}
            setShowNoOfMedication={setShowNoOfMedication}
            showNoOfMedication={showNoOfMedication}
            checkAllAction={checkAllAction}
            setCheckAllAction={setCheckAllAction}
            setMedications={setMedications}
            handleChangeAction={handleChangeAction}
            medicationActionCheck={medicationActionCheck}
            handleBlur={handleBlur}
            showWholeForm={showWholeForm}
            createOrderPadData={createOrderPadData}
            showOrderList={showOrderList}
            setIsOpenNewPatientPopup={setIsOpenNewPatientPopup}
            orderActionType={orderActionType}
            setOrderActionTypeActionType={setOrderActionTypeActionType}
            listOpen={listOpen}
            setListOpen={setListOpen}
            medicationRef={medicationRef}
            handleClickAddDrug={handleClickAddDrug}
            handleDrugChange={handleDrugChange}
            handleChangeQuantity={handleChangeQuantity}
            blankMediation={blankMediation}
            quantityRef={quantityRef}
            subscriptionDialog={subscriptionDialog}
            setSubscritionDialog={setSubscritionDialog}
          />
        )}
      {(query.get("actionType") === "createNewRx" ||
        currentPageType === "orderPad") && (
          <OrderToNewRx
            setFieldTouched={setFieldTouched}
            searchRepeatOrder={searchRepeatOrder}
            OrderingMethod={OrderingMethod}
            defaultOrderingMethod={
              searchRepeatOrder?.data?.data?.surgery_name?.ordering_method
            }
            handleSubmit={handleSubmit}
            selectedPatientInfo={selectedPatientInfo}
            query={query}
            setSelectedPatientInfo={setSelectedPatientInfo}
            setFieldValue={setFieldValue}
            handlePatientDetailsChange={handlePatientDetailsChange}
            currentPageType={currentPageType}
            touched={touched}
            errors={errors}
            setCreateDrug={setCreateDrug}
            medications={medications}
            values={values}
            handleChange={handleChange}
            navigate={navigate}
            orderType={orderType}
            showMedication={showMedication}
            setShowMedication={setShowMedication}
            setShowNoOfMedication={setShowNoOfMedication}
            showNoOfMedication={showNoOfMedication}
            checkAllAction={checkAllAction}
            setCheckAllAction={setCheckAllAction}
            setMedications={setMedications}
            handleChangeAction={handleChangeAction}
            medicationActionCheck={medicationActionCheck}
            handleBlur={handleBlur}
            showWholeForm={showWholeForm}
            handleDialog={handleDialog}
            createOrderPadData={createOrderPadData}
            showCreateNewRx={showCreateNewRx}
            setIsOpenNewPatientPopup={setIsOpenNewPatientPopup}
            orderActionType={orderActionType}
            setOrderActionTypeActionType={setOrderActionTypeActionType}
            listOpen={listOpen}
            setListOpen={setListOpen}
            medicationRef={medicationRef}
            handleClickAddDrug={handleClickAddDrug}
            handleDrugChange={handleDrugChange}
            handleChangeQuantity={handleChangeQuantity}
            blankMediation={blankMediation}
            quantityRef={quantityRef}
            subscriptionDialog={subscriptionDialog}
            setSubscritionDialog={setSubscritionDialog}
          />
        )}
      <DrugsDialog
        open={createDrug}
        setOpen={setCreateDrug}
        patient_id={selectedPatientInfo?.patient_id || selectedPatientInfo?.id}
        searchRepeatOrder={searchRepeatOrder}
        callBackOnSubmitPatientInfo={callBackOnSubmitPatientInfo}
        callBackOnCancelPatientInfo={callBackOnCancelPatientInfo}
      />
      <ViewOrderDialog
        open={openViewOrder}
        setOpen={setOpenViewOrder}
        viewOrderData={viewOrderData}
        actionType={query.get("actionType")}
        fromAddRx
        sendMail
        createTodayOrderPadAction={createTodayOrderPadAction}
        addRxMedi={medications}
        orderPadDataData={searchRepeatOrder?.data?.data}
        showNoOfMedication={showNoOfMedication}
        noofMediOrderPad={values?.number_of_medication}
        setInAddRx={setInAddRx}
      />
      <FaxDialog
        open={openFaxOrder}
        setOpen={setOpenFaxOrder}
        viewOrderData={viewOrderData}
        body={searchRepeatOrder?.data}
        actionType={query.get("actionType")}
        phone={phone}
        setPhone={setPhone}
        fax={fax}
        setFax={setFax}
      />
      <PatientCreateDialog
        open={isOpenNewPatientPopup}
        setOpen={setIsOpenNewPatientPopup}
        callBackOnSubmit={onSuccessOfSubmitPatientForm}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  createOrderPadData: state.orderPad.createOrderPadData,
  createRxDetails: state.collection.createRxDetails,
  searchRepeatOrder: state.order.searchRepeatOrder,
  createTodayOrderPadData: state.orderPad.createTodayOrderPadData,
  collectionViewRxDetails: state.collection.collectionViewRxDetails,
});

const mapDispatchToProps = (dispatch) => ({
  getCollectionRxAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_LIST, payload }),
  createCollectionRxAction: (payload) =>
    dispatch({ type: START_CREATE_RX, payload }),
  createTodayOrderPadAction: (payload) =>
    dispatch({ type: START_CREATE_TODAY_ORDER_PAD, payload }),
  getSearchRepeatOrderAction: (id) =>
    dispatch({ type: START_GET_SEARCH_REPEAT_ORDER, id }),
  resetOrderPadState: (key, payload) =>
    dispatch({ type: RESET_ORDER_PAD_STATE, key, payload }),
  resetRepeatOrderState: (key, payload) =>
    dispatch({ type: RESET_REPEAT_ORDER_STATE, key, payload }),
  resetCollectionRxState: (key, payload) =>
    dispatch({ type: RESET_COLLECTION_STATE, key, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionRXCreateMain);
